import * as L from 'leaflet';

const wildruhe = `https://services3.arcgis.com/hG7UfxX49PQ8XkXh/arcgis/rest/services/Wildruheflaechen_Tirol/FeatureServer/0/query?outFields=*&where=1%3D1&f=geojson`
const wald = `https://services3.arcgis.com/hG7UfxX49PQ8XkXh/arcgis/rest/services/Wald_und_Wildschutzzonen/FeatureServer/0/query?outFields=*&where=1%3D1&f=geojson`;
const attribution = `<a href='https://data-tiris.opendata.arcgis.com/datasets/tiris::wald-und-wildschutzzonen/about'>OGD Wald/Wild Tirol</a>`;

class WaldWild {

  map;
  featureGroup;
  areasLoaded = false;

  constructor(map, featureGroup) {
    this.map = map;
    this.featureGroup = featureGroup;
  }

  async loadAreas() {
    const zoom = this.map.getZoom();
    if (zoom <= 11) {
      this.areasLoaded = false;
      this.featureGroup.clearLayers();
      return;
    }
    if (this.areasLoaded === false) {
      L.geoJSON(await (await fetch(wildruhe)).json(), {
        attribution,
        style: () => {
          return {
            color: '#442222',
            weight: 1,
            fillOpacity: 0.3
          };
        },
        onEachFeature: (feature, layer) => {
          layer.bindPopup(`<h3>Wildruhe</h3>
          ${feature.properties.BEZEICHNUNG} <br>${feature.properties.BHBEZEICHNUNG}<br>
          © ${attribution}

            `);
        },
      }).addTo(this.featureGroup);
      L.geoJSON(await (await fetch(wald)).json(), {
        style: () => {
          return {
            color: '#006600',
            weight: 1,
            fillOpacity: 0.3
          };
        },
        onEachFeature: (feature, layer) => {
          layer.bindPopup(`<h3>Wald und Wildschutz</h3>
          ${feature.properties.OBJEKTBEZEICHNUNG}
          ${(feature.properties.LINK ? `<br><a href='${feature.properties.LINK}' target='_blank'>Bergwelt-Miteinander</a>` : '')} <br>
          © ${attribution}
            `);
        },
      }).addTo(this.featureGroup);
      this.areasLoaded = true;
    }
  }
}

const WaldWildLayer = L.FeatureGroup.extend({
  onAdd: async function (map) {
    const ww = new WaldWild(map, this);
    ww.loadAreas();
    map.on("moveend", () => {
      ww.loadAreas();
    })
  },
});

export { WaldWildLayer };
